<template>
  <div v-show="isCurrentStep" class="form-stepper__item">
    <slot />
  </div>
</template>

<script>
export default {
  provide() {
    const stepContext = {};

    Object.defineProperty(stepContext, 'index', {
      enumerable: true,
      get: () => this.index,
    });

    Object.defineProperty(stepContext, 'isCurrentStep', {
      enumerable: true,
      get: () => this.isCurrentStep,
    });

    Object.defineProperty(stepContext, 'isLastStep', {
      enumerable: true,
      get: () => this.isLastStep,
    });

    Object.defineProperty(stepContext, 'fields', {
      enumerable: true,
      get: () => this.fields,
    });

    Object.defineProperty(stepContext, 'initialFields', {
      enumerable: true,
      get: () => this.initialFields,
    });

    return {
      stepContext,
    };
  },
  inject: {
    stepperContext: {
      default() {
        return () => {};
      },
    },
    getFields: {
      default() {
        return () => {};
      },
    },
    getInitialFields: {
      default() {
        return () => {};
      },
    },
    getFieldErrors: {
      default() {
        return () => {};
      },
    },
  },
  data() {
    return {
      index: 0,
    };
  },

  computed: {
    fields() {
      return this.getFields();
    },
    initialFields() {
      return this.getInitialFields();
    },
    fieldErrors() {
      return this.getFieldErrors();
    },
    isCurrentStep() {
      return this.index === this.stepperContext.stepIndex;
    },
    isLastStep() {
      return (
        this.stepperContext.stepIndex === this.stepperContext.stepAmount - 1
      );
    },
  },

  mounted() {
    this.stepperContext.registerStep();
    this.index = this.getIndex();
  },
  methods: {
    getIndex() {
      const parent = this.$el.parentElement;
      const children = parent.children;
      return Array.from(children).findIndex(element => this.$el === element);
    },
  },
};
</script>
